export default __webpack_public_path__ + "static/media/hbs-k-cbb-2.11676b9f.png";